// extracted by mini-css-extract-plugin
module.exports = {"paneContainer":"CommerceSettings_paneContainer__3Yw9d","paddedContent":"CommerceSettings_paddedContent__1LK1s"};